export default {
  name: 'chanel',
  appId: 'wx8b5362b3e90cd150',
  wechatId: '212'
};